export const apiUrl = 'https://www.atrobot.asia/api1';
// export const apiUrl = 'http://localhost:7999';
// export const apiUrl = 'http://192.168.1.204:7999';

// export const apiUrl = 'http://[fe80::38b4:71ff:fe91:d6ac]:8000';
export const imageAPI = 'https://api1backend.atrobot.asia/api2';
// export const imageAPI = 'http://localhost:7000';